import React from "react";
//#region types
import { MonthRangeNavigatorProps } from "models/propTypes/datepickerPropTypes";
//#endregion
//#region components
import MonthRangePickerBase from "./monthRangePickerBase";
//#endregion
import cssExports from "theme/styles/main.module.scss";
import clsx from "clsx";

const MonthRangeNavigator: React.FC<MonthRangeNavigatorProps> = (props) => {
  return (
    <MonthRangePickerBase
      {...props}
      popperClassName="popperWithNavigator"
      popperPlacement="bottom"
      className={clsx(cssExports.datePickerNavigator, props.className)}
      showNavigators
    />
  );
};

export default MonthRangeNavigator;
